import React from 'react';
import type { CredentialingStatus } from 'types/credentialing';
import { EFeatureType } from 'types/provider';
import HomeStore from 'store/Home';
import { getBadgeMeta } from '../../statusMeta';
import { SvgInfoSmall } from '../SvgIcons';
import s from './s.module.less';

interface Props {
    status: CredentialingStatus;
    displayText?: string;
    contractSigned?: boolean;
}

const StatusBadge = ({ status, displayText, contractSigned }: Props) => {
    // 每行一个 badge，读页面已加载的 HomeStore，不各自请求 home
    const [getHomeStore] = HomeStore.useStore();
    const feeWaived = !!getHomeStore('data')?.features?.includes(EFeatureType.CREDENTIALING_FEE_WAIVED);
    const meta = getBadgeMeta(status, displayText, contractSigned, feeWaived);
    return (
        <span className={s.badgeTip}>
            <span className={`${s.badge} ${s[meta.badge]}`}>
                {displayText || meta.label}
                {meta.tip && <SvgInfoSmall />}
            </span>
            {meta.tip && <span className={s.badgeTipText}>{meta.tip}</span>}
        </span>
    );
};

export default StatusBadge;
